import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { setActiveTab } from '../../actions/profileForm';

import BrightnessTabs from './BrightnessTabs';
import BrightnessGraph from './BrightnessGraph';

import './deviceselectsidebar.scss';

const DeviceSelectSideBar = ({ profile, setActiveTab, activeTab }) => (
  <div className="device-select-sidebar">
    <h2 className="profile-name">{profile.name}</h2>
    <div className="profile-chart">
      <BrightnessTabs activeTab={activeTab} brightness={profile.brightness} onChange={setActiveTab} />
      <div className="chart-container">
        {profile.brightness[activeTab] ? (
          <BrightnessGraph brightness={profile.brightness[activeTab]} />
        ) : (
          <div style={{
            color: '#000',
            backgroundColor: '#E3E8EB',
            padding: 10,
            textAlign: 'center',
          }}>
            <p>Not configured (using default)</p>
          </div>
        )}
      </div>
    </div>
  </div>
)

export default connect(
  ( { profiles, ui }, { profileId } ) => ({
    profile: profiles.data.find(p => p.id === profileId),
    activeTab: ui.profileForm.activeTab // probably should have it's own state
  }),
  dispatch => ({
    setActiveTab: (tab) => dispatch(setActiveTab(tab)) // probably should have it's own action
  })
)(DeviceSelectSideBar)



// WEBPACK FOOTER //
// ./src/components/profiles/DeviceSelectSideBar.js